module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-tab-pc",
    attrs: {
      "id": "calendar-tab1"
    }
  }, [_c('calendar-header', {
    attrs: {
      "nameCodapp": _vm.labels[_vm.nowLang].nameCodapp,
      "linkToRedirect": _vm.linkToRedirect,
      "tooltip": _vm.header_tooltip
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "body-pc"
  }, [_vm._l((_vm.filterCalendarTab({
    tab: 'tab1',
    calendarTabRows: _vm.calendarTab1.rows
  })), function(value) {
    return [_c('filter-date', {
      attrs: {
        "showTabDate": _vm.showTabDate
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "panel-body add-border"
    }, [_c('div', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "head-tab-left font-bold  head-font",
      class: _vm.color[value.staappr]
    }, [_c('i', {
      staticClass: "font-padding fa",
      class: _vm.icon[value.staappr]
    }), _vm._v(_vm._s(value.status))]), _vm._v(" "), _c('div', {
      staticClass: "head-tab-right"
    }, [_vm._v("   " + _vm._s(_vm.setDateRangeOutput(_vm.dateRange(value.dtestrt, value.dteend))) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "color-green color-skin"
    }, [_c('i', {
      staticClass: "fa fa-clock-o font-padding"
    }), _vm._v(_vm._s(_vm.timeRange(value.timstrt, value.timend)))])])]), _vm._v(" "), _c('calendar-detail', {
      attrs: {
        "description": _vm.labels[_vm.nowLang].type,
        "descDetail": value.descType
      }
    }), _vm._v(" "), _c('calendar-detail', {
      attrs: {
        "description": _vm.labels[_vm.nowLang].description,
        "descDetail": value.descDetail
      }
    }), _vm._v(" "), (value.staappr == 'N') ? _c('calendar-detail', {
      attrs: {
        "description": _vm.labels[_vm.nowLang].remark,
        "descDetail": value.remark
      }
    }) : _vm._e()], 1)]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-239f5683!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/calendar_tab1.vue
// module id = 3626
// module chunks = 1